import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import { NavLink } from "react-router-dom";

function Blog() {
  return (
    <>
      <SEO
        title="Moironix Soft Solutions Blog | Latest Insights on Software Technology"
        description="Stay Updated with the Latest in Tech, Software Tips, Trends, and Insights from Moironix Soft Solutions"
        keywords="Custom Software Development, Software Solutions for Enterprises, Top Software Development Companies in Hyderabad, Best Software Companies in Hyderabad, Best IT companies in Hyderabad, Best Software Company in Hyderabad, Software Company in Hyderabad, Top Software Company in Hyderabad, Top 5 Software Company in Hyderabad, Mobile App Development, Custom Mobile App Development Hyderabad, Hybrid App Development Cost, React Native App Development Services, Flutter App Development for Startups, Mobile App Prototype Development, Mobile App Development Company, Android App Development Services, iOS App Development Services, Mobile App Developers, App Development Agency, Enterprise Mobile App Development, Application Development, Custom Web Application Development, PHP Application Development Services, Java Web Application Development, Net Application Development, SaaS Application Development, Web App Maintenance Services, Application Development Services, Web Application Development, Software Application Development, Custom Application Development, Web App Developers, Enterprise Application Development, Website Design and Development, Responsive Website Design, Ecommerce Website Development Cost, Website Redesign Services, Website Speed Optimization Services, Landing Page Design and Development, Website Design Company, Website Development Services, Web Design and Development, Ecommerce Website Development, Custom Website Design, Digital Marketing, Local Seo Services, Social Media Marketing, Content Marketing Strategy, Email Marketing Automation Services, Pay Per Click Management, Conversion Rate Optimization Services, Digital Marketing Agency, Seo Services, Social Media Marketing Services, Content Marketing Services, PPC Management, Digital Marketing Services, Graphic Design, Logo Design, Infographic Design Services, Brand Identity Design Package, Print Design Services, Ui/Ux Graphic Design, Motion Graphic Design Services, Graphic Design Services, Brand Design, Graphic Designers, Ui/Ux Design, Web Graphic Design"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Blog </h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">Blog </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-main">
        <section className="prt-row blog-section01 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="featured-imagebox-post-style1">
                  <div className="featured-post-overlay">
                    <div className="featured-post-thumbnail">
                      <img
                        style={{ height: "414px", width: "447px" }}
                        src="images/bl3.png"
                        className="img-fluid w-auto"
                        loading="lazy"
                        alt="image"
                      />
                    </div>
                    <div className="featured-post-content">
                      <div className="post-entry-date">20 Jan 2025</div>
                      <div className="prt-post-title">
                        <h3 className="post-h3">
                          <NavLink to="/blog-details" className="post-link">
                            The Developer’s Workspace: Immersed in Code ?
                          </NavLink>
                        </h3>
                      </div>
                      <div className="prt-post-catagory">
                        <div className="catagory-text">By _Srinivas</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="featured-imagebox-post-style1">
                  <div className="featured-post-overlay">
                    <div className="featured-post-thumbnail">
                      <img
                        style={{ height: "414px", width: "447px" }}
                        src="images/bl2.png"
                        className="img-fluid w-auto"
                        loading="lazy"
                        alt="image"
                      />
                    </div>
                    <div className="featured-post-content">
                      <div className="post-entry-date">03 Jan 2050</div>
                      <div className="prt-post-title">
                        <h3 className="post-h3">
                          <NavLink to="/blog-details" className="post-link">
                            Agile Development in Action: Team Collaboration
                          </NavLink>
                        </h3>
                      </div>
                      <div className="prt-post-catagory">
                        <div className="catagory-text">By _Gopal</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="featured-imagebox-post-style1">
                  <div className="featured-post-overlay">
                    <div className="featured-post-thumbnail">
                      <img
                        style={{ height: "414px", width: "447px" }}
                        src="images/bl1.png"
                        className="img-fluid w-auto"
                        loading="lazy"
                        alt="image"
                      />
                    </div>
                    <div className="featured-post-content">
                      <div className="post-entry-date">10 Jan 2025</div>
                      <div className="prt-post-title">
                        <h3 className="post-h3">
                          <NavLink to="/blog-details" className="post-link">
                            The Future of Software Development: A High-Tech
                            Vision ?
                          </NavLink>
                        </h3>
                      </div>
                      <div className="prt-post-catagory">
                        <div className="catagory-text">By _Vikas</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Blog;
